import * as React from "react";

import { Skeleton, SkeletonGenerator, Margins } from "@ui/Atoms";
import { Row, Column, Container } from "@ui/Atoms/Grid";

const HomeCleaningPageSkeleton = React.memo(() => (
  <Margins xs={["base_x2", "base_x2", null, null]}>
    <Container>
      <Row>
        <Column lg={10} xl={8}>
          <SkeletonGenerator
            count={6}
            shape="rectVertical"
            randomHeight={180}
          />
          <Skeleton shape="row" />
        </Column>
      </Row>
    </Container>
  </Margins>
));
HomeCleaningPageSkeleton.displayName = "HomeCleaningPageSkeleton";

export { HomeCleaningPageSkeleton };
